import { PresetType } from '../types'

/**
 * Форматы дат
 */
export const DATE_FORMATS = {
	/** Формат для отображения в инпуте: 20.12.2025 */
	DISPLAY: 'DD.MM.YYYY',
	/** Короткий формат для диапазона: 20.12.25 */
	SHORT: 'DD.MM.YY',
	/** Формат с текстом "Сегодня" */
	TODAY: '[Сегодня, ]DD.MM.YYYY',
	/** Формат с текстом "Вчера" */
	YESTERDAY: '[Вчера, ]DD.MM.YYYY',
} as const

/**
 * Placeholder для инпутов
 */
export const PLACEHOLDERS = {
	/** Placeholder для одной даты */
	SINGLE: '__/__/____',
	/** Placeholder для диапазона */
	RANGE: ['__/__/__', '__/__/__'],
} as const

/**
 * Русская локализация
 */
export const RU_LOCALE = {
	/** Названия месяцев (полные) */
	MONTHS: [
		'Январь',
		'Февраль',
		'Март',
		'Апрель',
		'Май',
		'Июнь',
		'Июль',
		'Август',
		'Сентябрь',
		'Октябрь',
		'Ноябрь',
		'Декабрь',
	],
	/** Сокращенные названия месяцев */
	MONTHS_SHORT: [
		'Янв',
		'Фев',
		'Мар',
		'Апр',
		'Май',
		'Июн',
		'Июл',
		'Авг',
		'Сен',
		'Окт',
		'Ноя',
		'Дек',
	],
	/** Названия дней недели (полные) */
	WEEKDAYS: [
		'Понедельник',
		'Вторник',
		'Среда',
		'Четверг',
		'Пятница',
		'Суббота',
		'Воскресенье',
	],
	/** Сокращенные названия дней недели (2 буквы) */
	WEEKDAYS_SHORT: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
	/** Текстовые метки */
	LABELS: {
		TODAY: 'Сегодня',
		YESTERDAY: 'Вчера',
		WEEK: 'Неделя',
		MONTH: 'Месяц',
		YEAR: 'Год',
		RESET: 'Сбросить',
		SELECT_DATE: 'Выберите дату',
	},
} as const

/**
 * Маппинг типов пресетов на их текстовые метки
 */
export const PRESET_LABELS: Record<PresetType, string> = {
	today: RU_LOCALE.LABELS.TODAY,
	yesterday: RU_LOCALE.LABELS.YESTERDAY,
	week: RU_LOCALE.LABELS.WEEK,
	month: RU_LOCALE.LABELS.MONTH,
	year: RU_LOCALE.LABELS.YEAR,
}

/**
 * Размеры календаря (в пикселях)
 */
export const CALENDAR_DIMENSIONS = {
	/** Ширина контейнера календаря */
	CONTAINER_WIDTH: 401,
	/** Высота контейнера календаря */
	CONTAINER_HEIGHT: 402,
	/** Размер ячейки дня (ширина и высота) */
	DAY_CELL_SIZE: 36,
	/** Горизонтальный отступ между ячейками */
	CELL_GAP_HORIZONTAL: 16,
	/** Вертикальный отступ между ячейками */
	CELL_GAP_VERTICAL: 11,
	/** Border radius для ячеек */
	CELL_BORDER_RADIUS: 8,
	/** Высота текста в шапке */
	HEADER_TEXT_HEIGHT: 24,
	/** Padding внутри контейнера календаря */
	CONTAINER_PADDING: 24,
} as const

/**
 * Количество дней в неделе
 */
export const DAYS_IN_WEEK = 7

/**
 * Количество отображаемых недель в календаре
 */
export const WEEKS_TO_DISPLAY = 6

/**
 * Количество месяцев в году
 */
export const MONTHS_IN_YEAR = 12

/**
 * Сетка месяцев для MonthPicker (строки x столбцы)
 * 4 строки x 3 столбца = 12 месяцев
 */
export const MONTH_GRID = {
	ROWS: 4,
	COLS: 3,
} as const

/**
 * Диапазон отображаемых годов в YearPicker
 */
export const YEAR_RANGE = {
	/** Количество лет до текущего года */
	BEFORE: 100,
	/** Количество лет после текущего года */
	AFTER: 10,
} as const

/**
 * Минимально допустимая дата/год для выбора в календаре
 */
export const MIN_YEAR = 2022 as const
export const MIN_DATE = new Date(MIN_YEAR, 0, 1)

/**
 * Продолжительность периодов в днях
 * Используется для пресетов. Для точного расчета года используется moment.js
 */
export const PERIOD_DURATIONS = {
	/** Неделя: 7 дней */
	WEEK: 7,
	/** Месяц: 30 дней (для простоты) */
	MONTH: 30,
} as const

/**
 * Разделитель для диапазона дат
 */
export const RANGE_SEPARATOR = '—'

/**
 * Первый день недели (0 - воскресенье, 1 - понедельник)
 */
export const FIRST_DAY_OF_WEEK = 1 // Понедельник

/**
 * Анимации (длительность в миллисекундах)
 */
export const ANIMATIONS = {
	/** Длительность анимации появления календаря */
	CALENDAR_OPEN: 200,
	/** Длительность анимации смены месяца */
	MONTH_CHANGE: 150,
} as const
